module.exports = __webpack_public_path__ + "img/3.60b39a05.jpg";